import {
    defineStore,
} from 'pinia'
import {
    useContextStore,
} from '~~/stores/context'
import { PROVIDERS } from '#shared/providers'

export const useGridPaneStore = defineStore('gridpane', () => {
    const PROVIDER = PROVIDERS.GRIDPANE

    const servers = ref([])
    const sites = ref([])

    const serverMap = computed(() =>
        Object.fromEntries(servers.value.map((server) => [server.id, server])),
    )

    const contextStore = useContextStore()
    contextStore.registerProvider(PROVIDER)

    const ctx = computed(() => contextStore.getContext(PROVIDER))
    watch(ctx, (newCtx, oldCtx) => {
        if (newCtx?.identityKey !== oldCtx?.identityKey) {
            servers.value = []
            sites.value = []
        }
    })

    async function fetchServers() {
        useRequest({
            label: 'fetch gridpane servers',
            fetch: () => $fetch('/api/gridpane/servers', {
                method: 'GET',
            }),
            evaluate: ({ servers: s }) => [...s],
            store: (s) => servers.value = s,
            successDetails: (s) => [s.length],
        })
    }

    async function fetchSites() {
        useRequest({
            label: 'fetch gridpane sites',
            fetch: () => $fetch('/api/gridpane/sites', {
                method: 'GET',
            }),
            evaluate: ({ sites: s }) => [...s],
            store: (s) => {
                sites.value = s.map((site) => ({
                    id: site.id,
                    url: site.url,
                    remoteBackup: site.remote_bup,
                    localBackup: site.local_bup,
                    serverId: site.server_id,
                    ssl: site.is_ssl,
                    sso: site.is_sso,
                    wsod: site.is_wsod,
                }))
            },
            successDetails: (s) => s.length,
        })
    }

    function init() {}

    async function createSite({ serverId, domain, systemUserName }) {
        return useRequest({
            label: 'create gridpane site',
            fetch: () => $fetch('/api/gridpane/sites', {
                method: 'POST',
                body: { serverId, domain, systemUserName },
            }),
            successDetails: () => [`${domain} on system user ${systemUserName}`],
        })
    }

    return { servers, sites, serverMap, init, fetchServers, fetchSites, createSite }
})
